export default __webpack_public_path__ + "1a80c74e3c2928f148f150678cd6570f.svg";